import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import { useNavigate, useParams } from "react-router-dom";
// import { IoMdArrowRoundBack } from "react-icons/io";
import BackHeader from "../components/backHeader";
import { BlackButton } from "../components/buttonContainer";
import { toast } from "react-toastify";
import { InfiLoader } from "../components/loader";
import { CountryAndStateData } from "../constants/constant";

function EditCustomer() {
  const { userData } = useUser();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;
  const [loading, setLoading] = useState(false);
  const [editCustomerLoading, setEditCustomerLoading] = useState(false);
  const { customerObjId } = useParams(); // Extract the ID from the URL
  const navigate = useNavigate();
  const [states, setStates] = useState([]);

  // const [showDeleteMemberPopup, setShowDeleteMemberPopup] = useState(false);
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    description: "",

    address: "",
    city: "",
    zipCode: "",
    country: "",
    countryCode: "",
    province: "",
    provinceCode: "",

    stores: false,
    products: false,
    orders: false,
    settings: false,
    reports: false,
    users: false,
    analytics: false,
  });

  console.log("formdata", formdata);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormdata({ ...formdata, [name]: value });
  // };
  // console.log(formdata);

  // const handleToggleChange = (key) => {
  //   setFormdata((prevFormData) => ({
  //     ...prevFormData,
  //     [key]: !prevFormData[key],
  //   }));
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Validate phone number to ensure it contains only digits and is not more than 10 digits
    if (name === "phone") {
      const isValidPhone = /^\d{0,10}$/.test(value); // Allow only up to 10 digits
      if (!isValidPhone) return; // Exit if the phone number is invalid
    }

    // Handle country selection
    if (name === "country") {
      const selectedCountry = CountryAndStateData[value];
      if (selectedCountry) {
        const { name: countryName, states } = selectedCountry;
        setStates(Object.entries(states)); // Dynamically update states dropdown
        setFormdata((prev) => ({
          ...prev,
          country: countryName, // Save country name
          countryCode: value, // Save country code
          province: "", // Clear province name
          provinceCode: "", // Clear province code
        }));
      } else {
        setStates([]); // Clear states dropdown if invalid country is selected
        setFormdata((prev) => ({
          ...prev,
          country: value,
          countryCode: "", // Clear country code
          province: "", // Clear province name
          provinceCode: "", // Clear province code
        }));
      }
      return; // Exit early after handling country change
    }

    // Handle province selection
    if (name === "province") {
      const selectedProvince = states.find(([code]) => code === value);
      if (selectedProvince) {
        const [provinceCode, provinceName] = selectedProvince;
        setFormdata((prev) => ({
          ...prev,
          province: provinceName, // Save province name
          provinceCode: provinceCode, // Save province code
        }));
      } else {
        setFormdata((prev) => ({
          ...prev,
          province: value,
          provinceCode: "", // Clear province code
        }));
      }
      return; // Exit early after handling province change
    }

    // Update form data for other inputs
    setFormdata((prevFormdata) => ({
      ...prevFormdata,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   if (userData?.vendorDetails?.vendorObjId) {
  //     fetchUserData(userData.vendorDetails.vendorObjId);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (userData?.vendorDetails?.vendorObjId) {
  //     fetchUserData(userData.vendorDetails.vendorObjId);
  //   }
  // }, [userData?.vendorDetails?.vendorObjId]);

  //   const fetchUserData = async (vendorObjId) => {
  //   setLoading(true);
  //   let payload = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //   });
  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/customer/get/${customerObjId}`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: payload,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log("Customer Data:", response.data.data);
  //       // setAppData(response.data.data);
  //       setLoading(false);
  //       // setUser(response?.data?.data)
  //       setFormdata({
  //         name: response?.data?.data?.name || "",
  //         email: response?.data?.data?.email || "",
  //         phone: response?.data?.data?.phone || "",
  //         role: response?.data?.data?.userType || "",
  //         description: response?.data?.data?.description || "",
  //         address: response?.data?.data?.addressDetails?.address || "",
  //         city: response?.data?.data?.addressDetails?.city || "",
  //         zipCode: response?.data?.data?.addressDetails?.zip || "",
  //         country: response?.data?.data?.addressDetails?.country || "",
  //         countryCode: response?.data?.data?.addressDetails?.country_code || "",
  //         province: response?.data?.data?.addressDetails?.province || "",
  //         provinceCode:
  //           response?.data?.data?.addressDetails?.province_code || "",
  //         stores: response?.data?.data?.permission?.stores || false,
  //         products: response?.data?.data?.permission?.products || false,
  //         orders: response?.data?.data?.permission?.orders || false,
  //         settings: response?.data?.data?.permission?.settings || false,
  //         reports: response?.data?.data?.permission?.reports || false,
  //         users: response?.data?.data?.permission?.users || false,
  //         analytics: response?.data?.data?.permission?.analytics || false,
  //       });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoading(false);
  //     });
  // };


  const fetchUserData = useCallback(
    async (vendorObjId) => {
      setLoading(true);

      let payload = JSON.stringify({
        vendorObjId: vendorObjId,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/customer/get/${customerObjId}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: payload,
      };

      axios
        .request(config)
        .then((response) => {
          console.log("Customer Data:", response.data.data);
          setLoading(false);

          setFormdata({
            name: response?.data?.data?.name || "",
            email: response?.data?.data?.email || "",
            phone: response?.data?.data?.phone || "",
            role: response?.data?.data?.userType || "",
            description: response?.data?.data?.description || "",
            address: response?.data?.data?.addressDetails?.address || "",
            city: response?.data?.data?.addressDetails?.city || "",
            zipCode: response?.data?.data?.addressDetails?.zip || "",
            country: response?.data?.data?.addressDetails?.country || "",
            countryCode:
              response?.data?.data?.addressDetails?.country_code || "",
            province: response?.data?.data?.addressDetails?.province || "",
            provinceCode:
              response?.data?.data?.addressDetails?.province_code || "",
            stores: response?.data?.data?.permission?.stores || false,
            products: response?.data?.data?.permission?.products || false,
            orders: response?.data?.data?.permission?.orders || false,
            settings: response?.data?.data?.permission?.settings || false,
            reports: response?.data?.data?.permission?.reports || false,
            users: response?.data?.data?.permission?.users || false,
            analytics: response?.data?.data?.permission?.analytics || false,
          });
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    },
    [customerObjId],
  );

  useEffect(() => {
    if (userData?.vendorDetails?.vendorObjId) {
      fetchUserData(userData.vendorDetails.vendorObjId);
    }
  }, [userData?.vendorDetails?.vendorObjId, fetchUserData]);

  // Custom toggle switch component
  // const Toggle = ({ name, checked, onChange }) => (
  //   <div className="flex justify-between">
  //     <label className="mr-2 text-lg">
  //       {name.charAt(0).toUpperCase() + name.slice(1)}
  //     </label>
  //     <div
  //       onClick={onChange}
  //       className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${checked ? "bg-gray-500" : "bg-gray-300"
  //         }`}
  //     >
  //       <div
  //         className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${checked ? "translate-x-6" : ""
  //           } transition-transform`}
  //       />
  //     </div>
  //   </div>
  // );
  // const handleBack = () => {
  //   navigate(`/customers/${customerObjId}`);
  // };

  const handleSubmit = async () => {
    setEditCustomerLoading(true);
    // Dynamically create `addressDetails` with unique keys for each field
    const addressDetails = {};

    // Loop through address-specific fields and dynamically add them as unique keys
    const addressFields = [
      "address",
      "city",
      "zipCode",
      "country",
      "countryCode",
      "province",
      "provinceCode",
    ];
    addressFields.forEach((field) => {
      if (formdata[field]) {
        addressDetails[`addressDetails.${field}`] = formdata[field];
      }
    });

    // Prepare the API payload
    const payload = {
      name: formdata.name,
      email: formdata.email,
      phone: formdata.phone,
      description: formdata.description,
      vendorObjId: vendorObjId, // Example vendor ID
      ...addressDetails, // Spread dynamic `addressDetails`
    };

    try {
      const response = await axios.put(
        `${apiurl}/admin/v1/customer/update/${customerObjId}`, // Example API URL
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("API Response:", response.data);
      if (response?.data?.success === true) {
        toast.success(
          response?.data?.message
            ? response?.data?.message
            : "Customer updated successfully",
        );
        navigate("/customers/all");
        setEditCustomerLoading(false);
      } else {
        toast.error(
          response?.data?.message
            ? response?.data?.message
            : "Failed to update customer",
        );
        setEditCustomerLoading(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to update customer, Please try again later.");
      setEditCustomerLoading(false);
    }
  };

  return (
    <Layout>
      <Container>
        {loading === true ? (
          <InfiLoader maintext="Fetching Customer Data" />
        ) : (
          <div className="flex flex-wrap justify-between w-full h-full">
            <div className="flex flex-col  py-2 px-2 md:px-14  w-[100%] h-[100%]">
              {/* <h2 className="text-2xl font-bold mb-4 text-slate-500 text-center p-4">
                            Edit Details
                        </h2> */}
              {/* <div className="flex items-center justify-between w-full">
                <div
                  className="flex items-center justify-center border border-slate-300 rounded-md w-8 h-8 cursor-pointer"
                  onClick={handleBack}
                >
                  <IoMdArrowRoundBack className="text-slate-500" />
                </div>
                <h2 className="text-xl md:text-2xl text-center flex-1 text-slate-500 font-bold">
                  Edit Details
                </h2>
              </div> */}

              <BackHeader
                title=" Edit Details"
                backButton={true}
                link={`/customers/view/${customerObjId}`}
                // rightSide={<BlackButton title="Edit" />}
              />
              <div className="mt-5  h-[90%] overflow-scroll">
                <p className="text-slate-500 font-semibold">Information:</p>
                <div className="px-10 py-3">
                  <div className="flex gap-4">
                    <div className="w-full">
                      <label className="text-sm text-slate-500">Name :</label>
                      <input
                        name="name"
                        value={formdata.name}
                        placeholder="Enter Name"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="w-full">
                      <label className="text-sm text-slate-500">Phone :</label>
                      <input
                        name="phone"
                        value={formdata.phone}
                        placeholder="Enter Phone No."
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-full">
                      <label className="text-sm text-slate-500">Email :</label>
                      <input
                        name="email"
                        value={formdata.email}
                        placeholder="Enter Email"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* <div className="w-full">
                    <label className="text-sm text-slate-500">Role :</label>
                    <select
                      name="role"
                      value={formdata.role}
                      className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                      defaultValue=""
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>
                        Select Role
                      </option>
                      <option value="user">User</option>
                      <option value="admin">Admin</option>
                   </select>
                  </div> */}
                    <div className="w-full">
                      <label className="text-sm text-slate-500">
                        Description :
                      </label>
                      <input
                        name="description"
                        value={formdata.description}
                        placeholder="Enter Description"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-full">
                      <label className="text-sm text-slate-500">
                        Address :
                      </label>
                      <input
                        name="address"
                        value={formdata.address}
                        placeholder="Enter Address"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-full">
                      <label className="text-sm text-slate-500">City :</label>
                      <input
                        name="city"
                        value={formdata.city}
                        placeholder="Enter City"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="w-full">
                      <label className="text-sm text-slate-500">
                        Zip code :
                      </label>
                      <input
                        name="zipCode"
                        value={formdata.zipCode}
                        placeholder="Enter Zip Code"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4">
                    {/* Country Selection */}
                    <div className="w-full">
                      <label className="text-sm text-slate-500">
                        Select Country :
                      </label>
                      <select
                        name="country"
                        value={formdata.countryCode} // Match key with the formdata object
                        onChange={handleInputChange}
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                      >
                        <option value="">Select Country</option>
                        {Object.entries(CountryAndStateData).map(
                          ([code, country]) => (
                            <option key={code} value={code}>
                              {country.name}
                            </option>
                          ),
                        )}
                      </select>
                    </div>

                    {/* Province Selection */}
                    <div className="w-full">
                      <label className="text-sm text-slate-500">
                        Select Province :
                      </label>
                      <select
                        name="province"
                        value={formdata.provinceCode} // Match key with the formdata object
                        onChange={handleInputChange}
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                      >
                        <option value="">Select Province</option>
                        {states.map(
                          (
                            [code, name], // Ensure `states` is dynamically updated
                          ) => (
                            <option key={code} value={code}>
                              {name}
                            </option>
                          ),
                        )}
                      </select>
                    </div>
                  </div>

                  {/* <div className="flex gap-4">
                     <div className="w-full">
                      <label className="text-sm text-slate-500">Country code :</label>
                      <input
                        name="countryCode"
                        value={formdata.countryCode}
                        placeholder="Enter Country Code"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div> 
                    <div className="w-full">
                      <label className="text-sm text-slate-500">Province code :</label>
                      <input
                        name="provinceCode"
                        value={formdata.provinceCode}
                        placeholder="Enter Province Code"
                        className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                        onChange={handleInputChange}
                      />
                    </div>
                  </div> */}
                  {/* <p className="text-slate-500 py-2 font-semibold">Permissions:</p>
                        <div className='flex flex-col gap-5'>
                            <div className="flex gap-4">
                                <div className="w-full">
                                    <Toggle
                                        name="stores"
                                        checked={formdata.stores}
                                        onChange={() => handleToggleChange("stores")}
                                    />
                                </div>
                                <div className="w-full">
                                    <Toggle
                                        name="products"
                                        checked={formdata.products}
                                        onChange={() => handleToggleChange("products")}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="w-full">
                                    <Toggle
                                        name="orders"
                                        checked={formdata.orders}
                                        onChange={() => handleToggleChange("orders")}
                                    />
                                </div>
                                <div className="w-full">
                                    <Toggle
                                        name="settings"
                                        checked={formdata.settings}
                                        onChange={() => handleToggleChange("settings")}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="w-full">
                                    <Toggle
                                        name="reports"
                                        checked={formdata.reports}
                                        onChange={() => handleToggleChange("reports")}
                                    />
                                </div>
                                <div className="w-full">
                                    <Toggle
                                        name="users"
                                        checked={formdata.users}
                                        onChange={() => handleToggleChange("users")}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="w-[49.2%]">
                                    <Toggle
                                        name="analytics"
                                        checked={formdata.analytics}
                                        onChange={() => handleToggleChange("analytics")}
                                    />
                                </div>
                            </div>
                        </div> */}
                  <div className="text-center">
                    {/* <button className="bg-slate-500 text-white px-20 py-2 rounded-md mt-4">
                  Save
                </button> */}
                    <BlackButton
                      title="Save"
                      handleSubmit={handleSubmit}
                      loading={editCustomerLoading}
                      loadingTitle="Saving..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
}

export default EditCustomer;
